export default {
  title: 'Ominaisuusliput',
  subtitle: 'Ota käyttöön tai poista käytöstä alustan ominaisuuksia yritykselle {{company}}.',
  no_company: 'Valitse ravintola hallinnoidaksesi sen ominaisuuslippuja.',
  columns: {
    feature: 'Ominaisuus',
    status: 'Tila',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (suora)',
      description:
        'Anna tämän ravintolan vastaanottaa PayPal-maksuja suoraan omaan PayPal-tiliinsä. Oletuksena käytössä Foodamigosin laskuttamien kumppaneiden ravintoloille, joissa asiakaspalvelumaksu peritään myös näistä maksuista ja alustan osuus laskutetaan kumppanilta.',
    },
    vip_free_flyers: {
      name: 'Kuukausittaiset ilmaiset mainoslehtiset',
      description:
        'Lähetä automaattisesti 500 mainoslehtistä kuukausittain tälle ravintolalle (oletus: käytössä VIP- ja Star-tasolla).',
    },
    custom_store_seo: {
      name: 'Mukautettu myymälän SEO',
      description: 'Anna tämän ravintolan hallita verkkokauppansa mukautettuja SEO-asetuksia.',
    },
    external_printer: {
      name: 'Ulkoinen kuittitulostin',
      description:
        'Anna tämän ravintolan yhdistää verkkokuittitulostin tilauspäätteen sovellukseen, sen sisäänrakennetun tulostimen sijaan.',
    },
    stripe_payment_element: {
      name: 'Stripe Payment Element -kassa',
      description:
        'Anna ravintolan oman Stripe-tilin päättää, mitä maksutapoja kassa tarjoaa. Ota käyttöön vasta, kun sen Stripe-alustalle on määritetty maksutavat liitetyille tileille.',
    },
  },
  toasts: {
    enabled: 'Ominaisuus otettu käyttöön.',
    disabled: 'Ominaisuus poistettu käytöstä.',
    error: 'Ominaisuutta ei voitu päivittää. Yritä uudelleen.',
    load_error: 'Ominaisuuslippuja ei voitu ladata.',
  },
};
